import { render } from "./icon-large-warehouse.vue?vue&type=template&id=06b110ed"
const script = {}

import exportComponent from "C:\\project\\webtrackandtrace\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__